import React from 'react';

const SectionNavigationDots = ({
  sections,
  activeSection = 0,
  onSectionClick,
  className = ''
}) => {
  const activeIndex = Number.isInteger(activeSection) ? activeSection : 0;

  return (
    <nav
      role="navigation"
      aria-label="Page sections navigation"
      className={`group/section-nav fixed right-4 sm:right-6 md:right-8 top-1/2 -translate-y-1/2 z-40 hidden md:block ${className}`}
    >
      <div className="flex flex-col gap-3 sm:gap-4 p-2">
        {sections.map((section, index) => {
          const isActive = activeIndex === index;

          return (
            <button
              key={section.id || index}
              type="button"
              onClick={() => onSectionClick(index)}
              aria-label={`Go to ${section.label}`}
              aria-current={isActive ? 'true' : 'false'}
              className="group/dot relative"
            >
              {/* Touch target (48x48px minimum) */}
              <div className="w-12 h-12 flex items-center justify-center">
                {/* Actual dot */}
                <div
                  className={`
                    rounded-full transition-all duration-300 ease-in-out
                    ${isActive
                      ? 'w-3 h-3 sm:w-3.5 sm:h-3.5 bg-gradient-to-br from-indigo-400 to-purple-400 shadow-lg shadow-indigo-500/50'
                      : 'w-2 h-2 sm:w-2.5 sm:h-2.5 bg-slate-500/30 group-hover/dot:bg-slate-400/50 group-hover/dot:scale-110'
                    }
                    focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500/50 focus-visible:ring-offset-2 focus-visible:ring-offset-slate-900
                  `}
                />
              </div>

              {/* Desktop tooltip (hidden on mobile) */}
              <span className="
                hidden md:block
                absolute right-full mr-3 top-1/2 -translate-y-1/2
                px-3 py-1.5 rounded-lg
                bg-slate-800/90 backdrop-blur-sm border border-slate-700/50
                text-slate-300 text-sm whitespace-nowrap
                opacity-0 group-hover/section-nav:opacity-100 group-focus-within/section-nav:opacity-100 group-hover/dot:opacity-100 group-focus-visible/dot:opacity-100
                transition-opacity duration-200
                pointer-events-none
              ">
                {section.label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default SectionNavigationDots;
